export class Candidato {
  PrcCdtCod: number;
  ensino: string;
  conclusao: string;
  concluinte: boolean;
  bolsa: boolean;
  PrcCdtEnemNum: string;
  PrcCdtEnemAno: any;
  instrumento: number;
  PeriodoEnsino: number;
  mediaCandidato: any;
}



// WEBPACK FOOTER //
// ./src/app/_shared/candidato/candidato.ts